<template>
  <div
    class="item"
    @click="clickItem"
  >
    <div class="title assetName-state">
      <div class="assetName-container">
        <div class="assetName">
          項目：{{ editableData.Name }}
        </div>
      </div>
      <div
        v-if="state"
        class="state-container"
      >
        <div
          class="state"
          :class="editableData.State"
        >
          {{ state }}
        </div>
      </div>
    </div>
    <div class="title assetPositionContainer">
      <div class="assetPosition">
        位置：{{ editableData.Location }}
      </div>
    </div>
    <div
      v-if="nextTime"
      class=" title nextTime"
    >
      應檢時間：{{ nextTime }}
    </div>
    <SupplierMaintenanceReport
      ref="supplierMaintenanceReport"
      :data="data"
      :category="category"
      @reported="onReported"
    />
  </div>
</template>

<script>
import SupplierMaintenanceReport from '../SupplierMaintenanceReport'
import dayjs from 'dayjs'
export default {
  components: {
    SupplierMaintenanceReport
  },
  props: {
    data: {
      type: Object
    },
    category: {
      type: String
    }
  },
  data (props) {
    const editableData = props.data
    return {
      editableData
    }
  },
  computed: {
    state () {
      switch (this.editableData.State) {
        case 'done':
          return '完成'
        default:
          return '未完成'
      }
    },
    isReportable () {
      return this.editableData.State !== 'done'
    },
    nextTime () {
      return this.editableData.NextTime ? dayjs(this.editableData.NextTime).format('YYYY-MM-DD') : ''
    }
  },
  methods: {
    clickItem (e) {
      e.stopPropagation()
      if (this.isReportable) {
        this.$refs.supplierMaintenanceReport.isReporting = true
      }
    },
    onReported (nextTime) {
      this.editableData.State = 'done'
      this.editableData.NextTime = nextTime
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid $borderDark4;
  gap: 5px;
  .title {
    height: 25px;
    display: flex;
    align-items: center;
  }
.assetName-state {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    $button: 70px;
    .assetName-container {
      flex-grow: 1;
      width: calc(100% - #{$button});
      .assetName {
        align-items: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .state-container {
      flex-basis: $button;
      .state {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        border-radius: 5px;
        box-sizing: border-box;
        color: $white;
        background: $appUndone;
        &.done {
          background: $appDone;
        }
      }
    }
  }
  .assetPositionContainer{
  .assetPosition{
      @include word-break-line(1)
  }
}
}
</style>
